import { jsx as _jsx } from "react/jsx-runtime";
import { Shape, StencilShape, SvgCanvas2D } from '@maxgraph/core';
import { useMemo, useRef } from 'react';
export const SchematicIcon = ({ icon, rotation, width, height, iconFill, iconStroke, context: { padding } }) => {
    const ref = useRef(null);
    let canvas = null;
    useMemo(() => {
        if (ref.current) {
            const startX = padding;
            const startY = padding;
            const endX = width - padding * 2;
            const endY = height - padding * 2;
            canvas = new SvgCanvas2D(ref.current, false);
            canvas.state.fillColor = iconFill;
            canvas.state.strokeColor = iconStroke;
            canvas.state.strokeWidth = 1;
            ref.current.innerHTML = '';
            if (icon instanceof StencilShape) {
                icon.drawShape(canvas, new Shape(), startX, startY, endX, endY);
            }
            else {
                icon.paintVertexShape(canvas, startX, startY, endX, endY);
            }
        }
    }, [ref.current, icon, width, height, iconFill, iconStroke, padding]);
    return _jsx("svg", { ref: ref, style: { rotate: rotation + 'deg' }, width: width, height: height, overflow: "visible" });
};
